// 🔹 Thinking Behavioural Scenario Bank

export const THINKING_BANK = [

  {
    id: "thk_01",

    dimension: "thinking",

    behaviour: "analytical_reasoning",

    scenario: "academic_performance",

    text: "You notice you've been doing much better in some subjects than others. What's the first thing you usually do?",

    options: [

      {
        label: "Try to figure out what's causing the difference",
        weights: { thinking: +2 }
      },

      {
        label: "Ask a teacher or friend what they think",
        weights: { thinking: +1 }
      },

      {
        label: "Work harder without thinking much about the reason",
        weights: { thinking: 0 }
      },

      {
        label: "Hope things improve on their own",
        weights: { thinking: -2 }
      }

    ]
  },

  {
    id: "thk_03",

    dimension: "thinking",

    behaviour: "critical_evaluation",

    scenario: "different_explanations",

    text: "Two teachers explain the same topic in different ways. You usually...",

    options: [
      {
        label: "Compare both explanations before deciding which makes more sense",
        weights: { thinking: +2 }
      },
      {
        label: "Ask questions to understand the differences",
        weights: { thinking: +1 }
      },
      {
        label: "Accept the explanation that seems easiest to understand",
        weights: { thinking: 0 }
      },
      {
        label: "Go with the first explanation you heard",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_03",

    dimension: "thinking",

    behaviour: "critical_evaluation",

    scenario: "online_information",

    text: "You read conflicting information online about the same topic. You usually...",

    options: [
      { label: "Compare sources before deciding what to believe", weights: { thinking: +2 } },
      { label: "Trust the most reliable source you know", weights: { thinking: +1 } },
      { label: "Accept whichever explanation seems reasonable", weights: { thinking: 0 } },
      { label: "Believe the first thing you read", weights: { thinking: -2 } }
    ]
  },

  {
    id: "thk_04",

    dimension: "thinking",

    behaviour: "pattern_recognition",

    scenario: "study_performance",

    text: "You realise some of your study methods work better than others. You usually...",

    options: [
      {
        label: "Look for patterns to understand what helps you learn best",
        weights: { thinking: +2 }
      },
      {
        label: "Think about what you did differently each time",
        weights: { thinking: +1 }
      },
      {
        label: "Keep studying the same way and hope your results improve",
        weights: { thinking: 0 }
      },
      {
        label: "Assume the results mostly depend on luck",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_05",

    dimension: "thinking",

    behaviour: "problem_solving",

    scenario: "difficult_question",

    text: "While doing your homework, you come across a question you don't know how to answer. You usually...",

    options: [
      {
        label: "Break the question into smaller parts and work through it",
        weights: { thinking: +2 }
      },
      {
        label: "Think of a few different ways to solve it before choosing one",
        weights: { thinking: +1, flexibility: +1 }
      },
      {
        label: "Try the first approach that comes to mind",
        weights: { thinking: 0 }
      },
      {
        label: "Skip it and hope someone else explains it later",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_06",

    dimension: "thinking",

    behaviour: "decision_making",

    scenario: "study_approach",

    text: "You have two different ways to prepare for an important test. You usually...",

    options: [
      {
        label: "Compare both approaches before deciding which one to use",
        weights: { thinking: +2 }
      },
      {
        label: "Choose the one that seems most practical",
        weights: { thinking: +1 }
      },
      {
        label: "Use the method you've always used",
        weights: { thinking: 0 }
      },
      {
        label: "Choose one quickly without thinking much about it",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_07",

    dimension: "thinking",

    behaviour: "evidence_based_reasoning",

    scenario: "group_assignment",

    text: "Your group can't agree on the best answer to a question. You usually...",

    options: [
      {
        label: "Suggest checking your notes or textbook to see which answer is supported",
        weights: { thinking: +2, control: +1 }
      },
      {
        label: "Discuss the reasons behind each answer before deciding",
        weights: { thinking: +1 }
      },
      {
        label: "Go with the answer most people agree on",
        weights: { thinking: 0 }
      },
      {
        label: "Choose any answer so the group can move on",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_08",

    dimension: "thinking",

    behaviour: "reflection",

    scenario: "marked_assignment",

    text: "After getting your marked assignment or test back, you usually...",

    options: [
      {
        label: "Look through your mistakes to see how you can improve next time",
        weights: { thinking: +2 }
      },
      {
        label: "Read the teacher's comments before putting it away",
        weights: { thinking: +1 }
      },
      {
        label: "Focus on the score and move on to the next assignment",
        weights: { thinking: 0 }
      },
      {
        label: "Put it away without looking at it again",
        weights: { thinking: -2 }
      }
    ]
  },

  {
    id: "thk_09",

    dimension: "thinking",

    behaviour: "attention_to_detail",

    scenario: "assignment_review",

    text: "Before handing in an important assignment, you usually...",

    options: [
      {
        label: "Carefully check everything to make sure you haven't missed anything",
        weights: { thinking: +2 }
      },
      {
        label: "Review the main parts before submitting",
        weights: { thinking: +1 }
      },
      {
        label: "Submit it if it looks mostly complete",
        weights: { thinking: 0 }
      },
      {
        label: "Hand it in without checking it again",
        weights: { thinking: -2 }
      }
    ]
  },

];